import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const CancelIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.87868 16.6066L12 13.4853L15.1213 16.6066C15.5118 16.9971 16.145 16.9971 16.5355 16.6066C16.9261 16.2161 16.9261 15.5829 16.5355 15.1924L13.4142 12.0711L16.5355 8.94975C16.9261 8.55922 16.9261 7.92606 16.5355 7.53553C16.145 7.14501 15.5118 7.14501 15.1213 7.53553L12 10.6569L8.87868 7.53553C8.48816 7.14501 7.85499 7.14501 7.46447 7.53553C7.07394 7.92606 7.07394 8.55922 7.46447 8.94975L10.5858 12.0711L7.46447 15.1924C7.07394 15.5829 7.07394 16.2161 7.46447 16.6066C7.85499 16.9971 8.48815 16.9971 8.87868 16.6066Z"
      />
    </Icon>
  );
};
